import styles from './style.module.css';
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import { useState } from 'react';
import { useRef } from 'react';
import Divider from '@material-ui/core/Divider';
import icsort from '../../../../../assets/ic-sort.svg';
import { SetDriverListCursor, SetDriverListCursorSort, SetOrderListCursor, SetOrderListCursorSort } from '../../../../../Redux/actions/actionNames';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../design-system/lib/Button';
//import Typography from '../../../../../design-system/lib/Typography';
import { isEqual } from 'lodash';
import Typography from '../../../../../design-system/lib/Typography';


export const SearchSortDriver = () => {

    const [showpoper, setShowpoper] = useState(false);
    const anchorEl = useRef(null);
    const dispatch = useDispatch();
    const cursor = useSelector((state) => state.DriversList.cursor)


    const cursorSort = useSelector((state) => state.DriversList.cursorSort)
    const { t, i18n } = useTranslation();
    const [selectedState, setSelectedState] = useState({
        cursor : cursor ,
        cursorSort: cursorSort ,
    });
    function handleshowpoper(e) {
        e?.preventDefault();
        e?.stopPropagation();
        setShowpoper(!showpoper)
    }
    function setCursor(item) {
        if (item != cursor) {
            dispatch(SetDriverListCursor(item))
        }
        handleshowpoper()
    }
    function setCursorSort(item) {
        if (item != cursorSort) {
            dispatch(SetDriverListCursorSort(item))
        }
        handleshowpoper()
    }


    return <div className={styles.searchSort} ref={anchorEl}>


        <Button isActive={showpoper} size='Small' type='Secondary' icon={icsort} className={styles.searchSortConditionIconNew} style={{ backgroundColor: showpoper ? "" : "transparent"  ,marginInlineStart :"4px"}} onClick={handleshowpoper} />
        {/*     <img src= className={styles.searchSortConditionIcon}  onClick={handleshowpoper}/>
            <div className={styles.titlesubContainer}>
                <span onClick={handleshowpoper} className={styles.searchSortTitle}> {t(cursor)} </span>
                <span onClick={handleshowpoper} className={styles.searchSortSubTitle}> {t(cursorSort)} </span>
            </div> */}

        <Popper
            open={showpoper }
            anchorEl={anchorEl.current}
            role={undefined}
            style={{
                zIndex: 12,
            }} placement={"bottom-end"}
            transition
            disablePortal
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    timeout={{ enter: 150, exit: 150 }}
                    style={{
                        transformOrigin:
                            placement === "bottom" ? "center top" : "center bottom",
                    }}
                >
                    <Paper style={{
                        zIndex: 6,
                        marginTop: "0",
                        border: "solid 1px rgba(128, 128, 128, 0.2)",
                        borderRadius: "10px",
                        boxShadow: "0 2px 8px 0 rgba(128, 128, 128, 0.24)",
                        padding: "0 0 0 0",
                        width: "150px" ,
                        direction : "initial"
                    }}>
                        <ClickAwayListener onClickAway={handleshowpoper}>
                            <MenuList id="menu-list-grow" style={{ padding: 0 }}>
                                <p className={styles.listTitle} style={{marginTop:"11px"}}>{t("Sort by")}</p>

                                <MenuItem
                                    onClick={() => {
                                       // setCursor("createdAt")
                                        setSelectedState({...selectedState , cursor : "lastOnlineTime"})
                                    }}
                                    className={styles.sortListItemContainer}
                                >
                                    <div className={selectedState.cursor == "lastOnlineTime" ? styles.fillCircle : styles.outlineCircle}>  </div>
                                    <span className={styles.itemTitle}> {t("Status")} </span>

                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                       // setCursor("dueDate")
                                        setSelectedState({...selectedState , cursor : "activeOrdersCount"})

                                    }}
                                    className={styles.sortListItemContainer}
                                >
                                    <div className={selectedState.cursor == "activeOrdersCount" ? styles.fillCircle : styles.outlineCircle}>  </div>
                                    <span className={styles.itemTitle}> {t("activeOrdersCount")}</span>

                                </MenuItem>
                                <Divider style={{ margin: "2px 16px" }} />

                                <p className={styles.listTitle}  style={{marginTop:"9px"}}>{t("Sort type")}</p>

                                <MenuItem
                                    onClick={() => {
                                      //  setCursorSort("asc")

                                        setSelectedState({...selectedState , cursorSort :"ascending" })

                                    }}
                                    className={styles.sortListItemContainer}
                                >
                                    <div className={selectedState.cursorSort == "ascending" ? styles.fillCircle : styles.outlineCircle}>  </div>

                                    <span className={styles.itemTitle}> {t("ascending")}</span>

                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                       // setCursorSort("desc")
                                        setSelectedState({...selectedState , cursorSort :"descending" })

                                    }}
                                    className={styles.sortListItemContainer}
                                >
                                    <div className={selectedState.cursorSort == "descending" ? styles.fillCircle : styles.outlineCircle}>  </div>

                                    <span className={styles.itemTitle}> {t("descending")}</span>

                                </MenuItem>
                                <div className={styles.footer}>
                                    <Typography weight='Body_Small_Semibold' textColor={'TextDark'} text={"Reset"} className={styles.drop} style={{opacity: (  !isEqual(selectedState, {
                                         cursor : "createdAt" ,
                                        cursorSort:  "asc" ,
                                    }) ) ? "1" : ".4", cursor: "pointer" }} onClick={(e) => {
                                        // e.stopPropagation();
                                        // setCurrentValue(null); onChange(null)
                                        setSelectedState({
                                            cursor : "lastOnlineTime" ,
                                            cursorSort: "ascending" ,
                                        })
                                        setCursor("lastOnlineTime")
                                        setCursorSort("ascending")
                                    }} />
                                    <Typography weight='Body_Small_Semibold' textColor={'Primary'} text={"Apply"} className={styles.drop} style={{ opacity: (  !isEqual(selectedState, {
                                         cursor : cursor ,
                                        cursorSort: cursorSort ,
                                    }) ) ? "1" : ".4", cursor: "pointer" }} onClick={() => {
                                        setCursor(selectedState.cursor)
                                        setCursorSort(selectedState.cursorSort)
                                    }} />
                                </div>
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    </div>

};




